import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { GroupSettingsState } from './group-settings.model';
import { withCallState } from '@shared/store-features/call-state-feature';
import { groupSettingsSlice } from './group-settings.slice';
import { playlistScheduleSlice } from './playlist-schedule.slice';
import { callStateStatusSlice } from './call-state-status.slice';

const useGroupSettingsStore = create<GroupSettingsState>()(
  devtools(
    (set, getState) => ({
      ...groupSettingsSlice(set),
      ...playlistScheduleSlice(set, getState),
      ...withCallState(getState),
      ...callStateStatusSlice(getState)
    }),
    { name: 'GroupSettingsStore' }
  )
);

export default useGroupSettingsStore;
